import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { useTranslation } from 'react-i18next';

export const VisitPaymentServiceDetails = ({ service }) => {
  const { t } = useTranslation();

  if (!service) return null;

  return (
    <Card>
      {/* Same header styling as VisitPaymentVisitDetails */}
      <CardHeader>
        <Heading variant="userAccountDetailsTitle">
          {service.name} {/* ONLY title from service */}
        </Heading>
      </CardHeader>
      <CardContent className="space-y-3">
        {/* All details come from payments */}
        {service.payments?.length > 0 && (
          <div className="space-y-4">
            {service.payments.map((p, idx) => (
              <div key={idx} className="space-y-1">
                {/* Price */}
                <div>
                  <span>{t('userAccount.visitTab.price')}</span>{' '}
                  <span>{p.price?.toFixed(2)}</span>
                </div>

                {/* Status */}
                <div>
                  <span>{t('userAccount.visitTab.state')}</span>{' '}
                  <span>{p.status ?? 'Neapmokėta'}</span>
                </div>

                {/* Payment Type */}
                <div>
                  <span>{t('userAccount.visitTab.payment')}</span>{' '}
                  <span>
                    {p.paymentType} – {p.price?.toFixed(2)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
      <CardFooter /> {/* SAME structure as VisitPaymentVisitDetails */}
    </Card>
  );
};
